import { createStackNavigator } from '@react-navigation/stack';
import React from 'react';
import { jobsDetailsConfig } from './config';
import { NAVIGATION_CONFIG } from '@v2/pages/common/constants/base.constants';

const JobDetailsStack = createStackNavigator();

const JobDetailsNavigator = () => {
  return (
    <JobDetailsStack.Navigator screenOptions={NAVIGATION_CONFIG}>
      {jobsDetailsConfig.map(({ Component, name }) => (
        <JobDetailsStack.Screen key={name} name={name} component={Component} />
      ))}
    </JobDetailsStack.Navigator>
  );
};

export { JobDetailsNavigator };
